import { Api } from 'utils';

class AvailabilityService {
  /**
   * Retorna las áreas del derecho en las que hay abogados disponibles
   * para el servicio y tipo de abogado indicados.
   *
   * @param params.service_id   - Constants.SERVICES.REVISION | PREPARATION | CHAT | SIGN
   * @param params.lawyer_type  - 'internal' | 'external' | 'both'
   * @param params.user_id      - ID del usuario cliente
   * @param params.document_id  - (opcional) ID del documento
   * @param params.state_id     - (solo Elaboración con abogado externo)
   * @param params.city_id      - (solo Elaboración con abogado externo)
   */
  static getAreas = async (params = {}) => Api.createResponse('app/availability/areas', params);
}

export default AvailabilityService;
